export function isAmlHold(res) {
  if (!res) return false;
  return res.held_for_review === true || res.heldForReview === true;
}

export function amlHoldCopy(res = {}) {
  return {
    title: res.popup_title || res.popupTitle || "Transaksi dalam tinjauan",
    body:
      res.popup_body ||
      res.popupBody ||
      res.msg ||
      res.message ||
      "Nominal transaksi Anda masuk dalam daftar tinjauan kepatuhan dan memerlukan pemeriksaan manual oleh tim kami. Dana belum dikirimkan. Transaksi akan diteruskan setelah peninjauan selesai.",
  };
}
